import { render, staticRenderFns } from "./AtencionesMedicas.vue?vue&type=template&id=7abdf8fa"
import script from "./AtencionesMedicas.vue?vue&type=script&lang=js"
export * from "./AtencionesMedicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports